import { Grid, Stack, Typography } from '@mui/material';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import { useTheme } from '@mui/system';
import { AppContainer } from 'components/AppContainer/AppContainer';
import { Header } from 'components/Header/Header';
import AppBodyContainer from 'components/AppBodyContainer/AppBodyContainer';
import { useTranslation } from 'react-i18next';
import { ReactElement } from 'react';

export function NotFoundPage(): ReactElement {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <AppContainer header={<Header />}>
      <AppBodyContainer data-testid="notFound">
        <Grid sx={{ height: '100%' }}>
          <Stack sx={{ alignItems: 'center', justifyContent: 'center' }} spacing={1}>
            <SentimentVeryDissatisfiedIcon sx={{ transform: 'scale(4)', height: '150px' }} />
            <Typography variant="h3" fontFamily="KingspanBrownTT-Bold">
              404
            </Typography>
            <Typography variant="h1" fontFamily="KingspanBrownTT-Bold">
              {t('not-found-page.title-page-not-found')}
            </Typography>
            <Typography sx={{ textAlign: 'center', color: theme.palette.text.secondary }}>
              {t('not-found-page.label-error-message')}
              <br />
              {t('not-found-page.label-error-instruction')}
            </Typography>
          </Stack>
        </Grid>
      </AppBodyContainer>
    </AppContainer>
  );
}
